module.exports = __webpack_public_path__ + "img/bolzano.ec8bf3e2.png";